'use strict';

angular.module('cgmemApp')
	.factory('User', function ($http, $state, $rootScope, $window, $log) {
		$window.dataLayer = $window.dataLayer || [];

		var user = null;
		var userP = null;

		var api = {}

		api.login = function (username, password) {
			user = null;
			userP = null;
			return $http.post('/auth/login', { username: username, password: password })
				.then(() => {
					$rootScope.$emit('authenticated');
				})
		}

		api.logout = function () {
			user = null;
			userP = null;
			return $http.post('/auth/logout', {})
				.then(function (d) {
					$rootScope.$emit('$sessionEnd');
					return user;
				})
				.catch(err => {});
		}

		api.resetRequest = function (username) {
			return $http.post('/auth/passwordresetrequest', { username: username });
		}

		api.get = function () {
			// get current user.  returns a promise
			if (userP)
				return userP;
			else
				return userP = $http.get('/api/me')
					.then(function (d) {
						$window.dataLayer.push({
							'userName': d.data.email,
							'userGroups': (d.data.groups && d.data.groups.join(' ')) || ''
						});
						return user = d.data;
					})
		}

		api.reset = function (email, token, password) {
			return $http.post('/auth/passwordreset', { email: email, token: token, password: password });
		}

		api.getSync = function () {			// FIX Do we need this?  authenticated.wrap uses it (unfortunately)
			return user;
		}

		api.isInGroup = function (group) {
			return (user && user.groups && user.groups.indexOf(group) >= 0)
		}

		$rootScope.$on('401',
			function () {
				$log.log("User Service: HTTP 401 event recieved: clearing session");
				$rootScope.$emit('$sessionEnd');
				user = null;
				$window.dataLayer.push({
					'userName': null
				});
			});

		return api;
	});
